import { createContext, Dispatch, useReducer } from 'react'

type Context = {
  message: string
  dispatch: Dispatch<any>
}
export enum ActionType {
  INPUT_MESSAGE = 'INPUT_MESSAGE',
  APPEND_LINK = 'APPEND_LINK',
}

interface MessageInputAction {
  type: ActionType
  payload: any
}

interface MessageState {
  message: string
}

export const MessageInputContext = createContext<Context>({
  message: '',
  dispatch: () => {},
})
const initialState = { message: '' }

const messageInputReducer = (
  state: MessageState,
  action: MessageInputAction,
) => {
  switch (action.type) {
    case 'INPUT_MESSAGE': {
      return {
        message: action.payload,
      }
    }
    case 'APPEND_LINK': {
      return {
        message: `${state.message} ${action.payload}`,
      }
    }
    default:
      return state
  }
}
const MessageInputContextProvider = ({ children }) => {
  const [store, dispatch] = useReducer(messageInputReducer, initialState)
  return (
    <MessageInputContext.Provider
      value={{
        message: store.message,
        dispatch,
      }}
    >
      {children}
    </MessageInputContext.Provider>
  )
}

export default MessageInputContextProvider
